/* 🤖 this file was generated by svg-to-ts */
export const matIconComputer: {
  name: 'computer';
  data: string;
} = {
  name: 'computer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"/></svg>`
};
